import { render, staticRenderFns } from "./VisitDialog.vue?vue&type=template&id=3bcd6950&scoped=true"
import script from "./VisitDialog.vue?vue&type=script&lang=js"
export * from "./VisitDialog.vue?vue&type=script&lang=js"
import style0 from "./VisitDialog.vue?vue&type=style&index=0&id=3bcd6950&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcd6950",
  null
  
)

export default component.exports